import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { collectionsApi, type CollectionListParams } from '../api/collections-api';

import { collectionKeys } from './collection-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function collectionListQueryOptions(storeId: string, params: CollectionListParams) {
  return queryOptions({
    queryKey: collectionKeys.list(storeId, params),
    queryFn: () => collectionsApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useCollections(storeId: string, params: CollectionListParams) {
  return useQuery(collectionListQueryOptions(storeId, params));
}
